import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Link } from '@/components/ui/link/link.component';
import { EntityTypeEnum } from '@/types/enums/entity-type.enum';
import { EntityAvatar } from '@/components/ui/avatar/entity-avatar';
import { SearchPartnerData } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { AnalyticsEnum } from '@/types/enums/analytics/analytics.enum';
import { checkLaboratorialOrVaccineSearch } from '@/app/_utils/check-laboratorial-or-vaccine-search.util';
import { SearchType } from '@/types/most-search-type';
import { getPartnerUrl } from '@/utils/partner-url.util';

interface SearchPartnerAvatarProps {
  professional: SearchPartnerData['professional'];
  partner: SearchPartnerData['partner'];
  searchType: string;
}

export const SearchPartnerAvatar = ({ professional, partner, searchType }: SearchPartnerAvatarProps) => {
  const analytics = getAnalyticsPlugin();
  const isLaboratorialOrVaccineSearch = checkLaboratorialOrVaccineSearch(searchType as SearchType);

  const trackAvatarClick = () => {
    analytics.track(AnalyticsEnum.CLICK_SEARCH_RESULT_AVATAR, { partner_id: partner.id });
  };

  return (
    <>
      {!isLaboratorialOrVaccineSearch && professional.avatar
        ? (
            <Link
              prefetch={false}
              href={`/profissionais/${professional.slug}/`}
              data-testid={DataTestIdEnum.SEARCH_CARD_PARTNER_AVATAR_LINK}
              onClick={trackAvatarClick}
            >
              <EntityAvatar
                size="4xl"
                className="w-22 h-22"
                alt={`Foto de perfil de ${professional.name}`}
                type={EntityTypeEnum.PROFESSIONAL}
                src={professional.avatar}
              />
            </Link>
          )
        : (
            <Link
              prefetch={false}
              href={getPartnerUrl(partner)}
              data-testid={DataTestIdEnum.SEARCH_CARD_PARTNER_AVATAR_LINK}
              onClick={trackAvatarClick}
            >
              <EntityAvatar
                size="4xl"
                className="w-22 h-22"
                alt={`Foto de perfil de ${partner.socialName}`}
                type={EntityTypeEnum.LABORATORY_COLLECT_POINT}
                src={partner.avatar}
              />
            </Link>
          )}
    </>
  );
};
